module.exports = __webpack_public_path__ + "img/18a001-01.39996bd5.png";